<div class="modal-content">
  <div class="row col-1 ml-auto">
    <span (click)="closeModal()" class="closebtn">x</span>
  </div>
  <div class="col-12">
    <div class="title-container col-12">
      <h2 class="modal-title">Status de Assinatura</h2>
    </div>

    <div class="container mb-3">
      <div class="description-box p-4">
        <p class="description-text">
        Para concluir o processo de pagamento de garantia, é necessário que
        todos os representantes legais da empresa assinem o Termo de Sub-rogação.
        </p>
      </div>


      <div class="modal-progress-section mb-5">
        <div class="progress-header">
          <span class="progress-label">Progresso</span>
          <span class="progress-counter">{{ andamentoAceite.numTotalAssinaturasRealizadas }}/{{ andamentoAceite.numTotalAssinaturasNecessarias }} assinaturas</span>
        </div>
        <div class="progress-bar-track">
          <div class="progress-bar-fill" [style.width.%]="andamentoAceite.progressoPorcentagem"></div>
        </div>
      </div>

      <div class="modal-representantes py-3">
        <h3 class="representantes-titulo">REPRESENTANTES LEGAIS</h3>

        <div
          *ngFor="let rep of andamentoAceite.representantes"
          class="representante-card"
          [ngClass]="rep.assinado ? 'card--assinado' : 'card--pendente'"
        >
          <div class="card-icon">
            <i class="fas" [ngClass]="rep.assinado ? 'fa-check-circle' : 'fa-info-circle'"></i>
          </div>

          <div class="card-info">
            <span class="card-titulo"> {{ rep.titulo }}</span>
            <span class="card-nome">{{ rep.nome }}</span>
            <span class="card-data" *ngIf="rep.assinado && rep.assinadoEm"> Assinado em {{ rep.assinadoEm | date: 'dd/MM/yyyy' }}</span>
            <span class="card-data card-data-aguardando" *ngIf="!rep.assinado"> Aguardando assinatura </span>
          </div>

          <span class="badge" [ngClass]="rep.assinado ? 'badge-success' : 'badge-warning'">
            {{ rep.assinado ? 'Assinado' : 'Pendente' }}
          </span>
        </div>
      </div>
    </div>


    <div class="voltarbtn p-5">
      <span (click)="closeModal()">Voltar à tela inicial</span>
    </div>
  </div>
</div>
